import { forwardRef } from 'react';

import { IconProps } from './';

export const GridIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={ref} {...props} {...{ className }}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 5H8.5C8.69811 5.00259 8.88737 5.08244 9.02747 5.22253C9.16756 5.36263 9.24741 5.55189 9.25 5.75V9C9.24741 9.19811 9.16756 9.38737 9.02747 9.52747C8.88737 9.66756 8.69811 9.74741 8.5 9.75H5.25C5.05109 9.75 4.86032 9.67098 4.71967 9.53033C4.57902 9.38968 4.5 9.19891 4.5 9V5.75C4.5 5.55109 4.57902 5.36032 4.71967 5.21967C4.86032 5.07902 5.05109 5 5.25 5ZM7.75 6.5H6V8.25H7.75V6.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.25 11.25H8.5C8.69811 11.2526 8.88737 11.3324 9.02747 11.4725C9.16756 11.6126 9.24741 11.8019 9.25 12V15.25C9.24741 15.4481 9.16756 15.6374 9.02747 15.7775C8.88737 15.9176 8.69811 15.9974 8.5 16H5.25C5.05109 16 4.86032 15.921 4.71967 15.7803C4.57902 15.6397 4.5 15.4489 4.5 15.25V12C4.5 11.8011 4.57902 11.6103 4.71967 11.4697C4.86032 11.329 5.05109 11.25 5.25 11.25ZM7.75 12.75H6V14.5H7.75V12.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.75 11.25H11.5C11.3011 11.25 11.1103 11.329 10.9697 11.4697C10.829 11.6103 10.75 11.8011 10.75 12V15.25C10.75 15.4489 10.829 15.6397 10.9697 15.7803C11.1103 15.921 11.3011 16 11.5 16H14.75C14.9481 15.9974 15.1374 15.9176 15.2775 15.7775C15.4176 15.6374 15.4974 15.4481 15.5 15.25V12C15.4974 11.8019 15.4176 11.6126 15.2775 11.4725C15.1374 11.3324 14.9481 11.2526 14.75 11.25ZM12.25 12.75H14V14.5H12.25V12.75Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 5H14.75C14.9481 5.00259 15.1374 5.08244 15.2775 5.22253C15.4176 5.36263 15.4974 5.55189 15.5 5.75V9C15.4974 9.19811 15.4176 9.38737 15.2775 9.52747C15.1374 9.66756 14.9481 9.74741 14.75 9.75H11.5C11.3011 9.75 11.1103 9.67098 10.9697 9.53033C10.829 9.38968 10.75 9.19891 10.75 9V5.75C10.75 5.55109 10.829 5.36032 10.9697 5.21967C11.1103 5.07902 11.3011 5 11.5 5ZM14 6.5H12.25V8.25H14V6.5Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default GridIcon;
